const TOKEN_KEY = 'bioweave_console_token';
const USER_REF_KEY = 'bioweave_console_user_ref';
const ROLE_KEY = 'bioweave_console_role';

export type StoredAuth = { token: string; userRef: string; role: string };

export const authStore = {
  load(): StoredAuth | null {
    const token = globalThis.localStorage?.getItem(TOKEN_KEY) ?? null;
    const userRef = globalThis.localStorage?.getItem(USER_REF_KEY) ?? null;
    const role = globalThis.localStorage?.getItem(ROLE_KEY) ?? null;
    if (!token || !userRef || !role) return null;
    return { token, userRef, role };
  },
  save(v: StoredAuth): void {
    globalThis.localStorage?.setItem(TOKEN_KEY, v.token);
    globalThis.localStorage?.setItem(USER_REF_KEY, v.userRef);
    globalThis.localStorage?.setItem(ROLE_KEY, v.role);
  },
  clear(): void {
    globalThis.localStorage?.removeItem(TOKEN_KEY);
    globalThis.localStorage?.removeItem(USER_REF_KEY);
    globalThis.localStorage?.removeItem(ROLE_KEY);
  },
};
